import type { CSSProperties } from 'react'
import { useState, useEffect, useRef } from 'react'
import { useDomSize } from 'src/hooks'
import 'src/styles/components/common/expandedRemark.less'

const ExpandedRemark = (props: {
  remark: string,
  expanded?: boolean,
  className?: string,
  style?: CSSProperties
}) => {
  const el = useRef<HTMLDivElement>(null)

  const domSize = useDomSize(el)

  const [isFlow, setIsFlow] = useState(false)
  useEffect(() => {
    el.current && setIsFlow(el.current.clientWidth < el.current.scrollWidth)
  }, [props.remark, domSize.clientWidth])

  const [expanded, setExpanded] = useState(false)
  useEffect(() => setExpanded(!!props.expanded), [props.expanded])

  return (
    <div className={`expanded-remark ${props.className}`} style={props.style}>
      <div ref={el} className='expanded-remark__detect'>{props.remark}</div>
      {
        expanded
          ? (
            <div
              dangerouslySetInnerHTML={{ __html: props.remark }}
              className='expanded-remark__remark'
              style={{ whiteSpace: 'normal' }}
            />
          )
          : (
            <div
              title={props.remark}
              className='expanded-remark__remark'
              style={{ whiteSpace: 'nowrap' }}
            >{props.remark}</div>
          )
      }
      {
        isFlow
          ? (
            <span
              onClick={() => setExpanded(prev => !prev)}
              className='expanded-remark__hold'
            >{expanded ? '收起' : '展开'}</span>
          )
          : null
      }
    </div>
  )
}

export default ExpandedRemark